import clsx from 'clsx'
import React, { FC } from 'react'

import { FormElementProps } from '@Components/FormElements/FormElementProps'

import styles from './BaseFormInput.module.scss'

export interface BaseFormInputProps extends FormElementProps {
  children?: React.ReactNode
  formActive: boolean
}

export const BaseFormInput: FC<BaseFormInputProps> = (
  {
    adornments,
    children,
    className,
    error,
    formActive,
    id,
    label,
    size = 'medium',
    variant = 'outlined',
    withoutLabelAnimation = false,
    wrapperClassName = '',
  }: BaseFormInputProps,
) => {
  const labelIsHidden = size === 'small' || withoutLabelAnimation

  return (
    <div
      className={clsx(
        styles.formInput,
        className,
        size === 'medium' && styles.formElementSizeMedium,
        size === 'small' && styles.formElementSizeSmall,
        variant === 'outlined' && styles.formElementVariantOutlined,
        variant === 'underlined' && styles.formElementVariantUnderlined,
        size !== 'small' && !withoutLabelAnimation && styles.formElementWithLabelAnimation,
        Boolean(adornments?.end) && styles.formElementsWithEndAdornment,
        Boolean(adornments?.start) && styles.formElementsWithStartAdornment,
        wrapperClassName,
      )}
    >
      <div
        className={clsx(styles.formElementInner, formActive && styles.formActive)}
      >
        <label
          className={clsx(labelIsHidden && styles.hidden)}
          htmlFor={id}
        >
          {label}
        </label>
        {adornments?.start && <div className={styles.startAdornment}>{adornments.start}</div>}
        {adornments?.end && <div className={styles.endAdornment}>{adornments.end}</div>}
        {children}
      </div>
      {error && <span className={styles.error}>{error}</span>}
    </div>
  )
}
